// extracted by mini-css-extract-plugin
module.exports = {"animatePing":"JabraLoader_animatePing__pxjXB","pingY":"JabraLoader_pingY__vw_KF"};